import React from 'react';
import { Box, FileUpload, StatusIndicator } from "@amzn/awsui-components-react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Button from "@amzn/awsui-components-react/polaris/button";

interface FileUploaderProps {
  file: File | undefined;
  handleFileChange: (files: File[]) => void;
  validateRedrive?: () => void;
  redriveOK: boolean;
  removeDuplicates?: () => void;
  loading: boolean;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  file,
  handleFileChange,
  validateRedrive,
  redriveOK,
  removeDuplicates,
  loading,
}) => {
  return (
    <SpaceBetween size="m">
      <SpaceBetween size="xs" direction="horizontal" alignItems="center">
        <Box variant="h2">New Redrive</Box>
      </SpaceBetween>

      <SpaceBetween size="xs" direction="horizontal" alignItems="center">
        <FileUpload
          accept="text/csv"
          onChange={({ detail }) => {
            handleFileChange(detail.value);
          }}
          i18nStrings={{
            uploadButtonText: (e) => (e ? "Replace File" : "Upload File"),
          }}
          value={file ? [file] : []}
          multiple={false}
        />
        {file && (
          <Box>{file.name}</Box>
        )}
        {redriveOK && file && (
          <SpaceBetween size="xs" direction="horizontal" alignItems="center">
            <StatusIndicator type="success" />
            <Box>Redrive Ready</Box>
          </SpaceBetween>
        )}
      </SpaceBetween>

      <SpaceBetween size="xs" direction="horizontal" alignItems="center">
        {validateRedrive && (
          <Button onClick={validateRedrive}>Validate Redrive</Button>
        )}
        {removeDuplicates && file && (
          <Button onClick={removeDuplicates}>Remove Duplicates</Button>
        )}
      </SpaceBetween>
    </SpaceBetween>
  );
};
